import { ClientOrchestrationShellSnapshot } from "@t3tools/contracts";
import * as Effect from "effect/Effect";
import * as Schema from "effect/Schema";
import { FetchHttpClient, HttpClient } from "effect/unstable/http";
import { environmentHttpClientLayer } from "./environmentHttp.js";
export function fetchShellSnapshot(input) {
    return Effect.runPromise(Effect.gen(function* () {
        const client = HttpClient.filterStatusOk(yield* HttpClient.HttpClient);
        const response = yield* client.get(input.url);
        return yield* response.json.pipe(Effect.flatMap(Schema.decodeUnknownEffect(ClientOrchestrationShellSnapshot)));
    }).pipe(Effect.provide(environmentHttpClientLayer(input.fetch)), Effect.provideService(FetchHttpClient.RequestInit, {
        ...input.requestInit,
        cache: "no-cache",
    }), Effect.timeout("15 seconds")));
}
